import React, { useState } from "react";
import { ROUTES } from "./Routes";
import SupervisorManagement from "./SupervisorManagement";
import SuperVisorRoutes from "./SupervisorRoutes";

const Supervisor = () => {
  const [route, setRoute] = useState(ROUTES.SUPERVISORS);
  const [supervisor, setSupervisor] = useState(null);
  switch (route) {
    case ROUTES.SUPERVISORS:
      return (
        <SupervisorManagement
          setPage={setRoute}
          setSupervisor={setSupervisor}
        />
      );
    case ROUTES.SUPERVISOR_ROUTES:
      return (
        <SuperVisorRoutes
          setPage={setRoute}
          setSupervisor={setSupervisor}
          supervisor={supervisor}
        />
      );
  }
};

export default Supervisor;
